/**
 * @desc 修改帮助文档
 */
import { HelpDocEntity, HelpDocForm } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateHelpDocParameter = HelpDocForm

const method = 'PUT'
const url = '/content/operation/help/doc'

export const updateHelpDocApi = (
  data?: UpdateHelpDocParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<HelpDocEntity>({
    method,
    url,
    data,
    ...config
  })
}

updateHelpDocApi.method = method
updateHelpDocApi.url = url
